module.exports = __webpack_public_path__ + "static/feature-5.68ae533d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/feature-5.png
// module id = 942
// module chunks = 72138227098318